/**
 * Whether a main-nav link should appear selected for the current pathname.
 * Uses longest-prefix matching so /dashboard/sales-onboarding does not also
 * select the broader /dashboard link.
 */
export function isMainNavActive(
    pathname: string,
    linkPath: string,
    allLinkPaths: string[]
): boolean {
    const path = pathname.replace(/\/$/, '') || '/';
    const link = linkPath.replace(/\/$/, '') || '/';
    const matches = path === link || path.startsWith(`${link}/`);
    if (!matches) return false;

    return !allLinkPaths.some((other) => {
        if (other === linkPath) return false;
        const otherPath = other.replace(/\/$/, '') || '/';
        const otherMatches = path === otherPath || path.startsWith(`${otherPath}/`);
        return otherMatches && otherPath.length > link.length;
    });
}
